// The member's course catalog, read live from the content service (tmi-ck2.44). It replaced the committed
// data/courses.json, which went stale against Contentful. One function, so store and component specs can mock it.
import type { CourseApiResponse, Courses } from "@tmi/types/api/content-models";
import { clientStateManager } from "@/services/error-services";
import { goFetchOrThrow } from "@/utils/network-utils";

/** The one page this reads. The catalog is ~10 courses; a full page means later courses are not shown. */
export const COURSES_CATALOG_PAGE_SIZE = 100;

/**
 * The raw catalog for this member, already product-gated by the server from the bearer token. goFetchOrThrow, not
 * goFetch: a failure rejects (typed, e.g. ServiceUnavailable before the server's first cache fill) instead of
 * resolving null, so the view can tell "could not load" from "no courses".
 */
export async function fetchCoursesCatalog( authToken: string, signal?: AbortSignal ): Promise< CourseApiResponse[] > {
    const response = await goFetchOrThrow< Courses, never >( {
        serverBaseUri: `${ import.meta.env.VITE_CONTENT_BASE_URI }`,
        // One unpaged read: `skip` is a PAGE INDEX on this catalog, so 0 is page one.
        endpoint: 'content/courses-catalog?skip=0&limit=100',
        verbOverride: 'GET',
        authToken,
        signal
    } );

    const courses: CourseApiResponse[] = response?.data?.coursesCatalog?.courses ?? [];
    if ( courses.length >= COURSES_CATALOG_PAGE_SIZE ) {
        clientStateManager.queueClientError( new Error( 'courses-catalog filled a whole page; later courses are not shown' ), { catalog: 'courses' } );
    }

    return courses;
}
